import React from "react";
import { Link } from "react-router-dom";
import s from "../styles/PolicyIndex.module.css";

const apps = [
    {
    id: "whitenoise",
    name: "White Noise: Calm Sleep",
    path: "/apps/whitenoise/privacy",
  },
  {
    id: "qrbarcode",
    name: "QR & Barcode Scanner: Fast Reader Pro",
    path: "/apps/qrbarcode/privacy",
  },
  {
    id: "smartgps",
    name: "Smart gps compass",
    path: "/apps/smartgps/privacy",
  },
  {
    id: "notespark",
    name: "Note Spark: Ai Note Taker",
    path: "/apps/notespark/privacy",
  },
  {
    id: "magicerace",
    name: "Magic Eracer: Remove object",
    path: "/apps/magicerace/privacy",
  },
  {
    id: "seekaichat",
    name: "Seek Ai Chat",
    path: "/apps/seekaichat/privacy",
  },
  {
    id: "nola",
    name: "Nola AI Chat Friend",
    path: "/apps/nola/privacy",
  },
  {
    id: "hwsolver",
    name: "Ai Homework Solver",
    path: "/apps/hwsolver/privacy",
  },
  {
    id: "photo_vaylt",
    name: "Veilify Photo Vault",
    path: "/apps/photo_vaylt/privacy",
  },
  {
    id: "voice_changer",
    name: "Voice changer pro",
    path: "/apps/voice_changer/privacy",
  },
  {
    id: "colorie_counter",
    name: "Ai Calorie counter: food tracker",
    path: "/apps/colorie_counter/privacy",
  },
  {
    id: "invoice_maker",
    name: "Invoice Maker for Contractors",
    path: "/apps/invoice_maker/privacy",
  },
  {
    id: "smart_spy",
    name: "Smart Spy Detector (MVP)",
    path: "/apps/smart_spy/privacy",
  },
  {
    id: "collage_ai",
    name: "Smart Collage Ai",
    path: "/apps/collage_ai/privacy",
  },
  {
    id: "trader_lab",
    name: "Trader Lab",
    path: "/apps/trader_lab/privacy",
  },
  {
    id: "wishflow",
    name: "WishFlow",
    path: "/apps/wishflow/privacy",
  },
  {
    id: "brainiq",
    name: "BrainIQ: Boost Your Mind",
    path: "/apps/brainiq/privacy",
  },
  {
    id: "puretrackervaping",
    name: "PureTracker: Quit Vaping",
    path: "/apps/puretrackervaping/privacy",
  },
  {
    id: "puretrackerdrinking",
    name: "PureTracker: Quit Drinking",
    path: "/apps/puretrackerdrinking/privacy",
  },
  {
    id: "pupverse",
    name: "Pupverse: Dog Training",
    path: "/apps/pupverse/privacy",
  },
  {
    id: "schedula",
    name: "Schedula",
    path: "/apps/schedula/privacy",
  },
];

export default function PrivacyIndex() {
  return (
    <div className={s.wrapper}>
      <h2>Privacy policy</h2>
      <ul className={s.appList}>
        {apps.map((app) => (
          <li key={app.id} className={s.appListItem}>
            <Link to={app.path} className={s.appLink}>
              {app.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
